<template>
  <div class="batch-impact-summary" v-if="impact.lines.length">
    <div class="batch-impact-summary__header">
      <i class="fas fa-exclamation-triangle"></i>
      <span>{{ trans.summary_title }}</span>
    </div>
    <ul class="batch-impact-summary__list">
      <li v-for="(line, i) in impact.lines" :key="i" class="batch-impact-summary__line"
          :class="'batch-impact-summary__line--' + line.level">
        <i :class="lineIcon(line.level)"></i><span>{{ line.text }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
import {computeBatchImpact} from '../show/batchImpact';

export default {
  name: 'batch-impact-summary',

  props: {
    'days': {
      type: Array,
      required: true
    },
    'selectedDays': {
      type: Array,
      required: true
    },
    'action': {
      type: String,
      required: true
    },
    'mode': {
      type: String,
      required: true
    },
    'trans': {
      type: Object,
      required: true
    }
  },

  computed: {
    impact() {
      return computeBatchImpact(this.days, this.selectedDays, this.action, this.mode, this.trans);
    }
  },

  methods: {
    lineIcon(level) {
      if (level === 'danger') return 'fas fa-fw fa-exclamation-circle';
      if (level === 'warning') return 'fas fa-fw fa-exclamation-triangle';
      return 'fas fa-fw fa-check-circle';
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-impact-summary {
  position: relative;
  padding: 14px 16px 14px 18px;
  margin-bottom: 18px;
  background: #fff8e9;
  border: 1px solid #f3d79a;
  border-left: 4px solid #F5BE30;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(120, 90, 20, 0.08);
}

.batch-impact-summary__header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 8px;
  border-bottom: 1px solid rgba(197, 152, 47, 0.25);
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #8a6512;

  i {
    font-size: 15px;
    color: #E0A70F;
  }
}

.batch-impact-summary__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.batch-impact-summary__line {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 3px 0;
  font-size: 14px;
  line-height: 1.5;
  color: #5c4a1f;

  i {
    margin-top: 2px;
    color: #a08749;
  }
}

.batch-impact-summary__line--warning {
  color: #9a5b00;
  font-weight: 600;

  i {
    color: #E0870F;
  }
}

.batch-impact-summary__line--danger {
  color: #c2183f;
  font-weight: 700;

  i {
    color: #FE3F61;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/show/BatchImpactSummary.vue